var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchivedJobs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 284,
    viewBox: "0 0 298 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 147.392L298 0V284H0V147.392Z",
    fill: "#DFE1E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89 128H209V154.667H89V128ZM95.6667 161.333H202.333V248H95.6667V161.333ZM132.333 181.333C131.449 181.333 130.601 181.685 129.976 182.31C129.351 182.935 129 183.783 129 184.667V194.667H169V184.667C169 183.783 168.649 182.935 168.024 182.31C167.399 181.685 166.551 181.333 165.667 181.333H132.333Z",
    fill: "#FFA15E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedJobs);
export default __webpack_public_path__ + "static/media/archivedJobs.27b8b1c207ca5add6a49f3890d79313f.svg";
export { ForwardRef as ReactComponent };